/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, computed, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';

export type OrchestrationType = 'Luis' | 'Conversation' | 'QuestionAnswering';

type QnaOrchestrationInfo = { projectName: string };

export type CluOrchestrationInfo = { projectName: string; slotName: string };
export type LuisOrchestrationInfo = { appId: string; versionId: string; slotName: string };
export type OrchestrationInfo =
    | ({ orchestrationType: 'Luis' } & LuisOrchestrationInfo)
    | ({ orchestrationType: 'Conversation' } & CluOrchestrationInfo)
    | ({ orchestrationType: 'QuestionAnswering' } & QnaOrchestrationInfo);

type CluIntentStoreData = OmitFunctions<Omit<CluIntentStore, 'id' | 'name' | 'orchestrationType'>>;

export class CluIntentStore {
    public id: string;

    public name: string;

    @observable public orchestrationInfo: OrchestrationInfo;

    constructor(intentName: string, dto: Partial<CluIntentStoreData>) {
        this.id = intentName;
        this.name = intentName;
        this.orchestrationInfo = dto.orchestrationInfo;
    }

    @computed
    public get orchestrationType(): OrchestrationType {
        return this.orchestrationInfo?.orchestrationType;
    }

    @action
    public setOrchestrationInfo(info: OrchestrationInfo) {
        this.orchestrationInfo = info;
    }
}
